import { validate as isUuid } from 'uuid'
import type { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'

export const selectableResourcesRequestId = (
  bomItemId: string,
  workingStepType: WorkingStepType,
  activityId?: string,
) => `get-selectable-resources-${bomItemId}-${workingStepType}-${activityId ?? 'legacy'}`

// Older working-step DTOs can carry a type-based key instead of an activity ID.
export const selectableResourcesActivityId = (
  activityId?: string,
  workingStepKey?: string,
) => activityId || (workingStepKey && isUuid(workingStepKey) ? workingStepKey : undefined)
